import React, { useEffect, useState } from "react";
import { getMatchesCard, getPubNubToken } from "../services/ScheduleService";
import axios from "axios";
import { ApiEndpoints } from "../services/ApiConstants";
import { initPubNub, subscribeToMatch } from "../services/PubNubService";
import LiveHero from "../components/Home/LiveHero";
import LiveMatchCard from "../components/Home/LiveMatchCard";
import ScheduleCard from "../components/Home/ScheduleCard";
import Sidebar from "../components/Home/Sidebar";
import CompletedMatchCard from "../components/Home/CompletedMatchCard";
import OddsStrip from "../components/Home/OddsStrip";

function Home({ token, userName }) {
    const [liveMatches, setLiveMatches] = useState([]);
    const [liveOdds, setLiveOdds] = useState({});
    const [nextMatchOdds, setNextMatchOdds] = useState(null);
    const [liveScores, setLiveScores] = useState({});
    const [completedMatches, setCompletedMatches] = useState([]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [activeTab, setActiveTab] = useState("recent");
    const subscribedMatchId = React.useRef(null);

    useEffect(() => {
        const fetchData = () => {
            getMatchesCard("live").then((data) => {
                if (data && data.matches && data.matches.length > 0) {
                    const actualLive = data.matches.filter(m => !m.matchEndTime);
                    setLiveMatches(actualLive);
                    actualLive.forEach((match) => {
                        axios.get(`${ApiEndpoints.BASE_URL}/matchConfig/latest-odds/${match.matchId}`)
                            .then((res) => {
                                if (res.data && res.data.apiStatus) {
                                    setLiveOdds(prev => ({ ...prev, [match.matchId]: res.data }));
                                }
                            })
                            .catch(() => {});
                    });
                    const match = data.matches[0];
                    if (subscribedMatchId.current !== match.matchId) {
                        subscribedMatchId.current = match.matchId;
                        getPubNubToken(userName, match.matchId, token).then((tokenData) => {
                            if (tokenData && tokenData.token) {
                                initPubNub(userName, tokenData.token);
                                subscribeToMatch(match.matchId, (message) => {
                                    if (message && message.body) {
                                        setLiveScores(prev => {
                                            const existing = prev[message.body.matchId];
                                            const newTime = new Date(message.body.timeStamp).getTime();
                                            const existingTime = existing ? new Date(existing.timeStamp).getTime() : 0;
                                            if (newTime < existingTime) return prev;
                                            return { ...prev, [message.body.matchId]: message.body };
                                        });
                                    }
                                });
                            }
                        });
                    }
                } else {
                    setLiveMatches([]);
                }
            });

            getMatchesCard("completed").then((data) => {
                if (data && data.matches) {
                    const completed = data.matches.filter(m => m.matchEndTime);
                    setCompletedMatches(completed.slice(0, 5));
                }
            }).catch((err) => {

            });

            getMatchesCard("upcoming").then((data) => {
                if (data && data.matches) {
                    const now = new Date();
                    const futureMatches = data.matches.filter(m => new Date(m.matchStartTime) > now);
                    setUpcomingMatches(futureMatches);
                    if (futureMatches.length > 0) {
                        axios.get(`${ApiEndpoints.BASE_URL}/matchConfig/latest-odds/${futureMatches[0].matchId}`)
                            .then((res) => {
                                if (res.data && res.data.apiStatus) {
                                    setNextMatchOdds({ match: futureMatches[0], odds: res.data });
                                }
                            })
                            .catch(() => {});
                    }
                }
            });
        };

        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            {liveMatches.length > 0 ? (
                liveMatches.map((match) => (
                    <div key={match.matchId}>
                        <LiveHero liveMatch={match} liveScore={liveScores[match.matchId] || null} />
                        <OddsStrip match={match} odds={liveOdds[match.matchId] || null} nextMatch={nextMatchOdds} />
                    </div>
                ))
            ) : (
                <LiveHero liveMatch={null} liveScore={null} />
            )}

            <div className="tabs-row" id="tabs-row">
                <button className={`tab-btn ${activeTab === "recent" ? "active" : ""}`} onClick={() => setActiveTab("recent")}>Recent</button>
                <button className={`tab-btn ${activeTab === "upcoming" ? "active" : ""}`} onClick={() => setActiveTab("upcoming")}>Upcoming</button>
            </div>

            <div id="section-home" className="spanel active">
                <div className="main-wrap">
                    <div className="main-grid">
                        <div>
                            {activeTab === "recent" && (
                                <div>
                                    <div className="sh">Recent Results</div>
                                    {liveMatches.length === 0 && completedMatches.length === 0 && (
                                        <p style={{ color: "var(--text2)", padding: "20px 0" }}>No matches right now.</p>
                                    )}
                                    {liveMatches.map((match) => (
                                        <LiveMatchCard key={match.matchId} match={match} liveScore={liveScores[match.matchId] || null} odds={liveOdds[match.matchId] || null} />
                                    ))}
                                    {completedMatches.map((match) => (
                                        <CompletedMatchCard key={match.matchId} match={match} />
                                    ))}
                                </div>
                            )}

                            {activeTab === "upcoming" && (
                                <div>
                                    <div className="sh">Upcoming Matches</div>
                                    {upcomingMatches.map((match, index) => (
                                        <ScheduleCard key={match.matchId} match={match} index={index} />
                                    ))}
                                </div>
                            )}
                        </div>
                        <Sidebar />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
